module.exports = __webpack_public_path__ + "img/pypi.72ad8bf1.svg";